import React from 'react'
import PropTypes from 'prop-types'
import { propType } from 'graphql-anywhere'
import { CardWrapper, CardContent, CardInnerHeading } from '../../../shared/settings/card'
import MySavedDevicesTable from './my-saved-devices-table'
import { SCREEN_SIZE_BREAKPOINTS } from '../../../../constants'
import { useScreenWidth } from '../../../../hooks/use-screen-width'

import styles from './devices.css'

import DEVICE_FRAGMENT from '../../../../../graphql/fragments/device.gql'

const MySavedDevicesCard = ({
  devices
}) => {
  const screenWidth = useScreenWidth()
  const isDesktopView = screenWidth >= SCREEN_SIZE_BREAKPOINTS.MIN_480
  const hasNoDevices = devices.length === 0

  return (
    <CardWrapper>
      <CardContent className={styles.cardContent}>
        {
          !hasNoDevices && (
            <CardInnerHeading
              className={styles.cardInnerHeading}
              header="My Saved Devices"
            />
          )
        }
        <MySavedDevicesTable
          isDesktopView={isDesktopView}
          devices={devices}
          hasNoDevices={hasNoDevices}
        />
      </CardContent>
    </CardWrapper>
  )
}

MySavedDevicesCard.propTypes = {
  devices: PropTypes.arrayOf(propType(DEVICE_FRAGMENT)).isRequired
}

export default MySavedDevicesCard
